// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { PaginationStyle } from "@conklin/MobiusOverrides/Pagination";
import { controlsContainerStyles } from "@conklin/Overrides/Widgets/ProductList/ProductListControlsContainer";
import IconLinkFilter from "@conklin/XDL/Icons/IconLinkFilter";
import { color, createLinkIconStyles, xScreen } from "@conklin/XDL/Utilities";
import Sliders from "@insite/mobius/Icons/Sliders";
import { css } from "styled-components";

controlsContainerStyles.container = {
    css: css`
        width: 100%;
        padding: 8px;
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        row-gap: 8px;
        background-color: ${color("common.ui2")};
        ${xScreen("lte", "md")} {
            flex-wrap: nowrap;
            & .hide-on-tablet {
                display: none;
            }
        }

        ${xScreen("lte", "sm")} {
            flex-wrap: wrap;
        }
    `,
};

controlsContainerStyles.leftColumn = {
    css: css`
        display: flex;
        align-items: center;
        gap: 31px;
        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
            padding: 0;
        }

        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
        }
    `,
};

controlsContainerStyles.rightColumn = {
    css: css`
        display: flex;
        justify-content: space-between;
        align-items: center;

        & div[data-test-selector="productList_pagination"] {
            margin: 0 !important;
            padding: 0;
        }

        ${xScreen("lte", "md")} {
            max-width: unset;
            width: auto;
            justify-content: flex-end;
        }
    `,
};

controlsContainerStyles.filterBtn = {
    ...createLinkIconStyles(IconLinkFilter),
};

controlsContainerStyles.tabletContainer = {
    css: css`
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        gap: 20px 16px;
        align-items: center;
        background-color: ${color("common.ui2")};
        padding: 8px;
        .pagination-page-number {
            margin-left: auto;
            ${PaginationStyle} {
                margin: 0;
            }
        }
    `,
};
